import {
  Button,
  FormContextWrapper,
  Input,
  Layout,
  useFormValues,
} from '@pimbutton/tast-components-lib';
import loginUser from 'actions/authentication/login';
import axios from 'axios';
import { AnimatePresence } from 'framer-motion';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { history } from 'components/App/components/UnauthenticatedApp';
import storeProject from 'actions/project/store';
import AuthVisual from '../AuthVisual/AuthVisual';
import NoAuthModal from '../NoAuthModal/NoAuthModal';

export default function Login() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { push } = useHistory();
  const dispatch = useReduxAction();

  const { formValues, handleChange, errors, setErrors } = useFormValues({
    email: '',
    password: '',
  });

  const { shareCode } = useParams();

  useEffect(() => {
    // get cookie we need for logging in
    axios.get('/sanctum/csrf-cookie').then(() => {});
  }, []);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    dispatch(loginUser(formValues))
      .then((e) => {
        if (shareCode) {
          dispatch(
            storeProject({
              fromShare: true,
              shareCode,
            })
          ).then(() => {
            history.push('/werkplaats/mijn-projecten');
          });
        }
      })
      .catch(({ response }: { response: any }) => {
        if (
          response?.data?.errors?.license &&
          response?.data?.errors?.license.length > 0 &&
          response.data.errors.license[0] === 'invalid'
        ) {
          setModalIsOpen(true);
        }
        setErrors((prev: any) => ({ ...prev, ...response?.data?.errors }));
      });
  }

  return (
    <>
      <Layout
        title="Inloggen"
        authVisual={<AuthVisual />}
        inputs={
          <FormContextWrapper
            onChange={handleChange}
            errors={errors}
            formValues={formValues}
          >
            <Input name="email" label="E-mailadres" placeholder="E-mailadres" />
            <Input
              name="password"
              label="Wachtwoord"
              placeholder="Wachtwoord"
            />
          </FormContextWrapper>
        }
        buttons={
          <>
            <Button fullWidth>Inloggen</Button>
            <Button
              fullWidth
              variant="white"
              onClick={() => push('/activeren')}
            >
              Activatiecode
            </Button>
            <Button
              fullWidth
              variant="white"
              onClick={() => push('/proefaccount')}
            >
              Proefaccount aanmaken
            </Button>
          </>
        }
        // MakeAccountFunc={() => push('/aanmelden')}
        forgotPasswordFunc={() => push('/wachtwoord/vergeten')}
        handleSubmit={(e) => handleSubmit(e)}
        color="#36B393"
      />
      <AnimatePresence>
        {modalIsOpen && <NoAuthModal setModalIsOpen={setModalIsOpen} />}
      </AnimatePresence>
    </>
  );
}
